<template>
    <div>
        <div class="title">
            <h3>Os campos com * são de preenchimento obrigatório</h3>
            <h5>Caso queira, você poderá salvar e continuar depois.</h5>
        </div>
        <div class="formulario">
            <div class="agrupamentoFormulario">
                <div class="categoriaAgrupamentoFormulario">
                    <LabelDisclaimer :TamanhoFonteLabel="'H5'" :NomeLabel="'Declarações de Vínculo do Cliente'"
                        :TipoCliente="'Pessoa Física'" :Sessao="'Declarações'" :SubSessao="'Vinculo cliente'" />
                </div>
                <div class="camposAgrupamentoFormulario">
                    <div class="row">
                        <div class="label__field" style="width: 60%">
                            <label class="label" for="nome">Você trabalha ou possui vínculo com a
                                {{ nomeEmpresa }}?*</label>
                            <div class="radio">
                                <input type="radio" id="true" value="true" name="VinculoRJI" class="field__radio"
                                    v-model="localPF.VinculoRJI" @change="salvarAlteracoesLocalmente" />
                                <label for="sim" class="label__radio">
                                    Sim
                                </label>
                                <input type="radio" id="false" value="false" name="VinculoRJI" class="field__radio"
                                    v-model="localPF.VinculoRJI" @change="salvarAlteracoesLocalmente" />
                                <label for="nao" class="label__radio">
                                    Não
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="agrupamentoFormulario">
                <div class="categoriaAgrupamentoFormulario">
                    <h5>PEP - Pessoa Exposta Politicamente</h5>
                </div>
                <div class="camposAgrupamentoFormulario">
                    <div class="row">
                        <div class="label__field" style="width: 85%">
                            <label class="label" for="nome">Você ou alguém de seu relacionamento exerce ou exerceu algum
                                cargo público nos últimos 5 anos?*</label>
                            <div class="radio">
                                <input type="radio" id="true" value="true" name="expostaPoliticamente"
                                    class="field__radio" v-model="localPF.ConhecePep"
                                    @change="salvarAlteracoesLocalmente" />
                                <label for="sim" class="label__radio">
                                    Sim
                                </label>
                                <input type="radio" id="false" value="false" name="expostaPoliticamente"
                                    class="field__radio" v-model="localPF.ConhecePep"
                                    @change="salvarAlteracoesLocalmente" />
                                <label for="nao" class="label__radio">
                                    Não
                                </label>
                            </div>
                        </div>
                        <div class="label__field" style="width: 15%; display: inline-flex;">
                            <img @click="abrirPepInformativo" style="width: 20px; height: 22px; cursor: pointer;"
                                src="@/assets/question.png" />
                            <label @click="abrirPepInformativo" class="label" for="nome"
                                style="color: #00235C; margin-left: 5px; cursor: pointer;">O que é PEP?</label>
                        </div>
                    </div>
                    <div class="row">
                        <div class="label__field" style="width: 100%">
                            <label class="label" for="nome">Se sim, especifique</label>
                            <textarea @change="salvarAlteracoesLocalmente" v-model="localPF.EspecificacaoPep"
                                style="width: 100%; height: 80px; max-height: 120px;" class="field"></textarea>
                        </div>
                    </div>

                </div>
            </div>
            <div class="agrupamentoFormulario">
                <div class="categoriaAgrupamentoFormulario">
                    <LabelDisclaimer :TamanhoFonteLabel="'H5'" :NomeLabel="'FATCA (Foreign Account Tax Compliance Act)'"
                        :TipoCliente="'Pessoa Física'" :Sessao="'Declarações'" :SubSessao="'FACTA'" />
                </div>
                <div class="camposAgrupamentoFormulario">
                    <div class="row">
                        <div class="label__field" style="width: 60%">
                            <label class="label" for="nome">Você é um cidadão americano ou possui Green Card?*</label>
                            <div class="radio">
                                <input type="radio" id="true" value="true" name="CidadaoAmericado" class="field__radio"
                                    v-model="localPF.CidadaoAmericado" @change="salvarAlteracoesLocalmente" />
                                <label for="sim" class="label__radio">
                                    Sim
                                </label>
                                <input type="radio" id="false" value="false" name="CidadaoAmericado"
                                    class="field__radio" v-model="localPF.CidadaoAmericado"
                                    @change="salvarAlteracoesLocalmente" />
                                <label for="nao" class="label__radio">
                                    Não
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="agrupamentoFormulario">
                <div class="categoriaAgrupamentoFormulario">
                    <LabelDisclaimer :TamanhoFonteLabel="'H5'" :NomeLabel="'Declarações'" :TipoCliente="'Pessoa Física'"
                        :Sessao="'Declarações'" :SubSessao="'Declarações'" />
                </div>
                <div class="camposAgrupamentoFormulario">
                    <div class="row">
                        <div class="label__field" style="width: 60%">
                            <label class="label" for="nome">Declaro que opero por conta:*</label>
                            <div class="radio">
                                <input type="radio" id="true" value="true" name="OperaPorConta" class="field__radio"
                                    v-model="localPF.OperaPorConta" @change="salvarAlteracoesLocalmente" />
                                <label for="sim" class="label__radio">
                                    Própria
                                </label>
                                <input type="radio" id="false" value="false" name="OperaPorConta" class="field__radio"
                                    v-model="localPF.OperaPorConta" @change="salvarAlteracoesLocalmente" />
                                <label for="nao" class="label__radio">
                                    de Terceiros
                                </label>
                            </div>
                        </div>
                    </div>
                    <DeclaracoesDocumentos />
                </div>
            </div>
        </div>
    </div>
    <ModalInformativoPep />
    <ModalInformativoDocumentosDeclaracoesVue />
</template>

<script>

import LabelDisclaimer from '../Utilitarios/Disclaimer/LabelDisclaimer.vue'
import { mapGetters } from 'vuex';
import ModalInformativoDocumentosDeclaracoesVue from '../Documentos/ModalInformativoDocumentosDeclaracoes.vue';
import ModalInformativoPep from '../PEP/ModalInformativoPep.vue'
import DeclaracoesDocumentos from './DeclaracoesDocumentos.vue';

export default {
    name: 'CadastroPF_Declaracoes',
    props: ['informacoesDeclaracoes', 'Edicao'],
    components: { ModalInformativoPep, ModalInformativoDocumentosDeclaracoesVue, DeclaracoesDocumentos, LabelDisclaimer },
    computed: {
        ...mapGetters({
            user: 'auth/user',
            etapaCadastro: 'GET_ETAPA_CADASTRO',
            listaDocumentos: 'GET_LISTA_DOCUMENTOS',
            listaDocumentosCliente: 'GET_LISTA_DOCUMENTOS_CLIENTE'
        }),
    },
    mounted() {
        this.nomeEmpresa = process.env.VUE_APP_NOME_EMPRESA;
    },
    data() {
        return {
            permitirAvancar: false,
            localPF: this.informacoesDeclaracoes,
            nomeEmpresa: ''
        }
    },
    watch: {
        listaDocumentosCliente() {
            this.validarFormulario();
        }
    },
    methods: {
        abrirPepInformativo() {
            this.$store.commit('SET_MODAL_PEP_INFORMATIVO', true);
        },
        validarFormulario(submeter) {
            this.permitirAvancar = true;
            var nomeDoCampo = '';
            if (this.listaDocumentos != null) {
                this.listaDocumentos.forEach(documentoObj => {
                    if (documentoObj.TipoCliente == 'Pessoa Física' && documentoObj.Obrigatoriedade == 'Sim') {

                        if(!this.listaDocumentosCliente){
                            this.permitirAvancar = false;
                            nomeDoCampo = documentoObj.NomeDocumento;
                        }else if (!this.listaDocumentosCliente.some(p => p.TemplateId === documentoObj.TemplateId) ||
                                this.listaDocumentosCliente.some(p => p.TemplateId === documentoObj.TemplateId && p.Status == 'Pendente')) {
                                this.permitirAvancar = false;
                                nomeDoCampo = documentoObj.NomeDocumento;
                        }
                    }
                });
            }
            if (submeter && nomeDoCampo != '') {
                this.$swal({
                    icon: 'warning',
                    title: 'Oops...',
                    text: `O documento ` + nomeDoCampo + ` é obrigatório e não foi assinado, aceito os termos para avançar`,
                });
            }
        },
        proximaEtapa() {
            this.validarFormulario(true);
            if (this.permitirAvancar) {
                this.$store.commit('SET_ETAPA_CADASTRO', 7);
                this.$store.commit('SET_SALVAR_INFO_DES_NOTIFICACAO', true);
                this.salvarInformacoes();
            }
        },
        salvarInformacoes() {
            this.$store.commit('SET_PF_SALVAR_INFO', true);
        },
        salvarAlteracoesLocalmente() {
            this.$store.commit('SET_PF_SALVAR_INFO_DECLARACOES', this.localPF);
        },
    }
}

</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap');

.formulario {
    width: 100%;
}

.agrupamentoFormulario {
    width: 100%;
    display: inline-flex;
    margin-top: 10px;
}

.categoriaAgrupamentoFormulario {
    width: 13%;
    margin-right: 15px;
    font-family: 'Inter', sans-serif;
    span {
        font-weight: 400 !important;
        font-size: 13px;
        color: #667085;
    }
}

.label__field {
    padding-right: 30px;
}

.camposAgrupamentoFormulario {
    width: 90%;

    .row {
        width: 100%;
        display: inline-flex;
        gap: 8px;
        margin-bottom: 10px;
    }

    .accept {
        display: inline-flex;

        &:checked {
            +label {
                &:before {
                    background: white;
                    border: 1px solid black;
                    transition: background 0.3s;
                }
            }

            +label {
                &::after {
                    opacity: 1;
                    transition: all;
                    background: transparent;
                }
            }
        }
    }

    .field {
        border-radius: 8px;
        border: 1px solid #D0D5DD;
        padding: 10px 14px;
        background-color: white;
        width: 100%;
    }

    .radio {
        display: flex;
        align-items: center;
        margin-right: 25px;

        @media (max-width: 768px) {
            margin-right: 0;
            margin-bottom: 20px;
        }

        .field__radio {
            width: 20px;
            height: 20px;
        }

        .fieldInRadio {
            border-radius: 8px;
            border: 1px solid #D0D5DD;
            padding: 10px 14px;
            background-color: #F9FAFB;
            width: 55%;
        }

        .label__radio {
            margin-left: 5px;
            margin-right: 40px;
            margin-top: 5px;
        }
    }

    select {
        width: 105% !important;
    }

    label {
        font-family: 'Inter', sans-serif;
        font-weight: 500;
        font-size: 14px;
        line-height: 20px;
        color: #344054;
        display: block;
        margin-bottom: 8px;
    }
}





.title {

    border-bottom: 1px solid #EAECF0;

    h3 {
        margin-top: 50px;
        color: #101828;
        font-weight: 500;
        font-family: 'Inter', sans-serif;

    }

    h5 {
        margin-top: 5px;
        margin-block-start: 0;
        color: #667085;
        font-weight: 400;
        font-family: 'Inter', sans-serif;
    }
}
</style>